/**
 * Placeholder events: advertised without date/time/location finalized; no registration.
 * Mirror of server/utils/eventPlaceholder.js (UI + API display).
 */

export const EVENT_PLACEHOLDER_TBA = "TBA";
export const EVENT_PLACEHOLDER_REGISTRATION_MESSAGE =
  "Registration is not open for this event yet. Details coming soon.";

export function isPlaceholderEvent(event) {
  return Boolean(event && event.is_placeholder);
}

/** Date line for calendar/admin cards: TBA when placeholder has no start. */
export function formatPlaceholderAwareEventDate(event, formatFn) {
  if (!event) return "—";
  if (isPlaceholderEvent(event) && !event.start_datetime) return EVENT_PLACEHOLDER_TBA;
  if (!event.start_datetime) return "—";
  return typeof formatFn === "function" ? formatFn(event.start_datetime) : String(event.start_datetime);
}

/** Location line: TBA when placeholder has no location. */
export function formatPlaceholderAwareEventLocation(event) {
  if (!event) return "—";
  const loc = (event.location != null ? String(event.location) : "").trim();
  if (loc) return loc;
  if (isPlaceholderEvent(event)) return EVENT_PLACEHOLDER_TBA;
  return "—";
}
